import React, { useEffect } from 'react'
import SettingsIcon from '@mui/icons-material/Settings'
import TabDataTools from './TabDataTools'

function DatabaseFunctions(props) {
    // trigger on component mount
    useEffect(() => {
        document.title = 'BI Cloud - Data Tools'
    })

    // This is the render logic, no need to declare another method is a functional component
    return (<div className="mainWrapper">
        <div className="bodyPart">
            <div className="contentWrapper">
                <h2 className="pageHead">
                    <SettingsIcon />
                    {' '}
                    Database Functions
                </h2>
                <div className="tabOutMain">
                    <TabDataTools
                        dbList={props.dbList}
                        getDataSources={props.getDataSources}
                        showPopup={props.showPopup}
                        jobs={props.jobs}
                        histories={props.histories}
                        selfServeJobs={props.selfServeJobs}
                        globalFiles={props.globalFiles}
                        downloadFile={props.downloadFile}
                        role={props.role}
                        selfServiceChangeFilesPage={props.selfServiceChangeFilesPage}
                        selfServiceChangeJobsPage={props.selfServiceChangeJobsPage}
                        selfServiceChangeHistoriesPage={props.selfServiceChangeHistoriesPage}
                        openEditNewWizardFile={props.openEditNewWizardFile} />
                </div>
            </div>
        </div>
    </div>)
}

export default DatabaseFunctions